import { Component, Input, OnInit } from '@angular/core';
import { ControlContainer, NgForm } from '@angular/forms';
import { EveReportingControlWidgetWidget } from '../../../../../services/ControlWidgetService.service';




@Component({
  selector: 'datetime-input-control-widget-menu-settings',
  templateUrl: 'datetime-input-control-widget-menu-settings.component.html',
  styleUrls: ['./datetime-input-control-widget-menu-settings.component.css'],
  viewProviders: [
    { provide: ControlContainer, useExisting: NgForm }
  ]
})
export class DateTimeInputControlWidgetMenuSettingsComponent implements OnInit {

  @Input()
  widget?: EveReportingControlWidgetWidget = null;

  constructor(

  ) {


  }
    ngOnInit(): void {
      
    }


}



